if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super()
      }

      hide() {
        super.hide()
      }

      show(opener) {
        super.show(opener)
        this.showActiveMedia()
        this.initializeCarouselWithMedia()
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`
        ).forEach((element) => {
          element.classList.remove("active")
        })
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`)
        const activeMediaTemplate = activeMedia.querySelector("template")
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
        activeMedia.classList.add("active")
        activeMedia.scrollIntoView()

        const container = this.querySelector('[role="document"]')
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent()
      }

      initializeCarouselWithMedia() {
        // Set the initial media ID in the carousel for proper initialization
        const carousel = this.querySelector(".product__essentials-carousel")
        const clickedMediaId = this.openedBy.getAttribute("data-media-id")

        if (carousel && clickedMediaId) {
          carousel.setAttribute("data-initial-media-id", clickedMediaId)

          // Trigger a custom event to notify the carousel of the initial media
          const event = new CustomEvent("modalCarouselOpen", {
            detail: { initialMediaId: clickedMediaId },
          })
          document.dispatchEvent(event)
        }
      }
    }
  )
}
